import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=253269c4&scoped=true"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"
import style0 from "./Labels.vue?vue&type=style&index=0&id=253269c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253269c4",
  null
  
)

export default component.exports